import { createAction, props } from '@ngrx/store';

export const SetScreenSize = createAction('[Shared: Breakpoint]: Set Screen Size', props<{ size: string }>());
